import React from 'react';
import Loader from 'react-loader-spinner';

function LoaderIndicator(props) {
  return (
    <Loader
      className="pl-2"
      visible={true}
      type="ThreeDots"
      color={props.color ? props.color : '#042e60'}
      height={props.small ? 10 : 80}
      width={props.small ? 20 : 80}
    />
  );
}

export default LoaderIndicator;
